import { ValueChartItem } from "../Components/PercentValueChart/ValueChart";
import ValueChartData from "../Components/PercentValueChart/ValueChartData";


/**
 * Represents the popularity stats data that we receive from the server. This data will be 
 * shown on a graph on the analytics page
*/
export default class TopReferrerStats extends ValueChartData {
    public getChartData(): ValueChartItem[] {
        const datasetSum: number = this.dataset.reduce((carry: number, item: ValueChartItem) => carry += item.value, 0);
        const otherDomainsSum = this.getChartTotal() - this.other - datasetSum;

        const retval = [
            {
                name: "Other Domains",
                value: otherDomainsSum,
                children: [],
            },
            ...this.dataset,
            {
                name: "Direct, Email, Sms",
                value: this.other,
                children: [],
            },
        ];

        if (otherDomainsSum === 0) {
            retval.shift();
        }

        return retval;
    }
}
